import PropTypes from "prop-types";
import classnames from "classnames";

import {productPropType} from "apps/QuoterApp/validation/propTypes";
import ButtonInput from "shared/components/ButtonInput";
import Skeleton from "shared/components/Skeleton";
import PremiumDisplay from "shared/components/PremiumDisplay";

import spinner from 'apps/QuoterApp/assets/images/Spinner.svg';

import "./styles.scss";


function ProductItem({item, loading, onApply, selected, onSelect}) {
    if (!item) {
        return <div className={'ProductItem'}>
            <Skeleton className={"ProductItem__CompanyLogo"}/>
            <div className={"ProductItem__Data"}>
                <Skeleton className={"ProductItem__Data__Title"}/>
                <PremiumDisplay className={"ProductItem__Data__Premium"}/>
                <Skeleton className={"ProductItem__Data__Apply"}/>
            </div>
        </div>;
    }

    const {id, image, name, company, premium} = item;

    return <div
        key={id}
        className={classnames('ProductItem', {'Selected': selected})}
        onClick={() => onSelect(id)}
    >
        <div className={"ProductItem__CompanyLogo"}>
            <img src={image} alt={company}/>
        </div>
        <div className={"ProductItem__Data"}>
            <div className={"ProductItem__Data__Title"}>{name}</div>
            <PremiumDisplay className={"ProductItem__Data__Premium"} premium={premium}/>
            {loading
                ? <img className={"ProductItem__Data__Spinner"} src={spinner} alt={"Loading..."}/>
                : <ButtonInput className={"ProductItem__Data__Apply"} onClick={() => onApply(item)}>Apply</ButtonInput>
            }
        </div>
    </div>;
}

// TODO: Move to separate file
ProductItem.propTypes = {
    item: productPropType,
    loading: PropTypes.bool,
    onApply: PropTypes.func,
    selected: PropTypes.bool,
    onSelect: PropTypes.func,
};

ProductItem.defaultProps = {
    loading: false,
};

export default ProductItem;
